import { BrowserRouter, Routes, Route } from "react-router-dom";
import MainOutlet from "./MainOutlet";
import Home from "./Home";
import Poem from "./Poem";
import OldHome from "./OldHome";
import ShowVideo from "./ShowVideo";
const MainRoute = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path={'/'} element={<MainOutlet />}>
                    <Route path={''} element={<Home />} />
                    <Route path={'/video'} element={<ShowVideo />} />
                </Route>
                <Route path={'/old'} element={<MainOutlet />}>
                    <Route path={''} element={<OldHome />} >
                    </Route>
                    <Route path={'poetry_reading'}
                        element={
                            <Poem
                                pageName="poetry_reading"
                            />} >

                    </Route>
                    <Route path={'poetry_music_reading'}
                        element={
                            <Poem
                                pageName="poetry_music_reading"
                            />} >
                    </Route>
                    <Route
                        path={'ancient_chinese_reading'}
                        element={
                            <Poem
                                pageName="ancient_chinese_reading"
                            />
                        }
                    >
                    </Route>
                    <Route
                        path={'rhythm_enlightenment'}
                        element={
                            <Poem
                                pageName="rhythm_enlightenment"
                            />
                        }
                    >
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter >

    );
}
export default MainRoute;